import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import { api, formatDateTimeBR, maskCPF, maskPhone } from "../lib/api";
import { Lock, Loader2, Search, ArrowRight } from "lucide-react";

export default function BlockedClientesPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    let on = true;
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/clients", { params: { blocked: true } });
        if (on) setItems(Array.isArray(data) ? data : []);
      } catch (_) {
        if (on) setItems([]);
      } finally {
        if (on) setLoading(false);
      }
    })();
    return () => { on = false; };
  }, []);

  const filtered = items.filter((c) => {
    if (!q.trim()) return true;
    const s = q.toLowerCase();
    return (c.full_name || "").toLowerCase().includes(s) || (c.cpf || "").includes(s) || (c.block_reason || "").toLowerCase().includes(s);
  });

  return (
    <Layout>
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6">
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-red-300 flex items-center gap-1.5"><Lock size={11}/> Operação restrita</div>
          <h1 className="font-display text-3xl sm:text-4xl font-bold mt-1">Clientes bloqueados</h1>
          <p className="text-[13px] text-[#A3A3A3] mt-2 max-w-2xl">
            Clientes nesta lista <strong>não podem criar contratos novos, renovar ou receber link de assinatura</strong> até serem desbloqueados.
          </p>
        </div>
        <div className="relative w-full sm:w-72">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#737373]"/>
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Buscar por nome, CPF ou motivo"
            className="fc-input pl-9"
            data-testid="blocked-search"
          />
        </div>
      </div>

      {loading ? (
        <div className="flex items-center gap-2 text-[#737373] text-sm"><Loader2 size={14} className="animate-spin"/> Carregando...</div>
      ) : filtered.length === 0 ? (
        <div className="fc-card p-8 text-center">
          <Lock size={28} className="text-[#737373] mx-auto mb-3"/>
          <div className="text-sm text-[#A3A3A3]">{items.length === 0 ? "Nenhum cliente bloqueado." : "Nenhum cliente bate com a busca."}</div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
          {filtered.map((c) => (
            <Link
              key={c.id}
              to={`/clientes/${c.id}`}
              className="fc-card p-4 hover:border-red-500/30 transition-colors block"
              data-testid={`blocked-row-${c.id}`}
            >
              <div className="flex items-start justify-between gap-2 mb-2">
                <div className="min-w-0">
                  <div className="text-[15px] font-semibold truncate">{c.full_name}</div>
                  <div className="text-[11.5px] text-[#737373] mt-0.5">{c.cpf ? maskCPF(c.cpf) : "—"} · {c.whatsapp ? maskPhone(c.whatsapp) : "—"}</div>
                </div>
                <span className="badge-base bg-red-500/10 border-red-500/30 text-red-300 text-[10px] flex-shrink-0">
                  <Lock size={9}/> Bloqueado
                </span>
              </div>
              <div className="text-[12.5px] text-[#A3A3A3] mt-2">
                <span className="text-[#737373]">Motivo:</span> {c.block_reason || "—"}
              </div>
              <div className="text-[11px] text-[#737373] mt-2 flex items-center justify-between">
                <span>{c.blocked_at ? formatDateTimeBR(c.blocked_at) : ""}</span>
                <span className="flex items-center gap-1 text-[#D4AF37]">Abrir <ArrowRight size={11}/></span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </Layout>
  );
}
